'use client';

import { useState } from 'react';
import VideoSplashScreen from '@/components/ui/VideoSplashScreen';
import Header from '@/components/common/Header';
import HeroSection from './components/HeroSection';
import AerospaceSectors from './components/AerospaceSectors';
import CapabilitiesShowcase from './components/CapabilitiesShowcase';
import MissionGallery from './components/MissionGallery';
import TrustSignals from './components/TrustSignals';
import PlatformPreview from './components/PlatformPreview';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePageClient() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <>
      {!splashDone && (
        <VideoSplashScreen onComplete={() => setSplashDone(true)} />
      )}
      <main className="min-h-screen bg-background">
        <Header />
        <HeroSection />
        <AerospaceSectors />
        <CapabilitiesShowcase />
        <MissionGallery />
        <TrustSignals />
        <PlatformPreview />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}
